// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__PCZOR","content":"Layout_content__6qwkP","contentWrapper":"Layout_contentWrapper__Aca7r","gradientHolder":"Layout_gradientHolder__9w-la"};